// extracted by mini-css-extract-plugin
export default {"cls1":"WorkCard-cls1_O_j","cls2":"WorkCard-cls2__Xn WorkCard-cls1_O_j"};